import React, { useState } from "react";
import styled from "styled-components";
import { Header, ProgressBar } from "./components";
import Logo from "../../assets/hdfc-life.png";

const Container = styled.div`
  height: 100%;
  display: flex;
  padding: 0px 24px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

const BackgroundImage = styled.img`
  width: 100%;
  margin-top: 35px;
`;

const CenterContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  gap: 8px;

  margin-top: 42px;
  box-sizing: border-box; /* Ensures padding is included in width calculation */
`;

const Address = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #2f313b;
`;

const Coordinates = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #2f313b;
`;
const BottomButtons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: auto;
  margin-bottom: 20px;
  gap: 16px; /* Ensures 16px gap */
  box-sizing: border-box;
`;
const SkipButton = styled.button`
  background: transparent;
  border: none;
  color: #2f313b;
  font-size: 16px;
  font-weight: 600;
  width: 30%;
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px;

  &:hover {
    opacity: 0.8;
  }

  span {
    font-size: 12px;
    font-weight: 400;
    color: #6c757d;
  }
`;
const NextButton = styled.button`
  background: rgb(51, 51, 51);
  color: white;
  border: none;
  padding: 10px 50px;
  border-radius: 6px;
  width: 50%;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  &:disabled {
    background: #ccc;
    color: #fff;
    cursor: not-allowed;
  }
`;
const InputField = styled.input`
  width: 100%;
  max-width: 300px;
  padding: 12px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 6px;
  outline: none;
  &:focus {
    border-color: #05a8aa;
    box-shadow: 0 0 5px rgba(5, 168, 170, 0.5);
  }
`;
const Image = styled.img`
  width: 180px;
  height: 57px;
  margin-bottom: 16px;
  margin-top: 30px;
`;

// const ProgressBar = styled.div`
//   width: 100%;
//   height: 4px;
//   background-color: #e0e0e0;
//   margin: 8px 0;

//   &::after {
//     content: "";
//     display: block;
//     width: 10%;
//     height: 100%;
//     background-color: #20564b;
//   }
// `;
const Footer = styled.footer`
  font-size: 12px;
  font-weight: 400;
  color: #6e6f76;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px 0px;

  box-sizing: border-box; /* Ensures padding is included in width calculation */
`;

const DateOfBirth = ({ onProceedWithPassword }) => {
  const [dob, setDob] = useState("");

  // Handle input change
  const handleInputChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // Remove non-digit characters
    setDob(value.slice(0, 8)); // Ensure only 8 digits (4 for DOB + 4 for MON)
  };
  return (
    <Container>
      <ProgressBar currentStep={3} totalSteps={7} type="dark" />

      <Image src={Logo} alt="Logo" />
      <BackgroundImage src="/src/assets/images/shield.svg" alt="Background" />
      <CenterContent>
        <Address>
          Enter the combination of DOB and Mobile Number of policy owner
        </Address>
        <InputField
          type="text"
          placeholder="Enter 4-digit DOB + 4-digit MON"
          value={dob}
          onChange={handleInputChange}
          maxLength={8}
        />
      </CenterContent>
      <Footer>
        <span>
          For e.g. DOB is <strong>31-05-1999</strong> and Mobile No.
          <strong>981194232</strong>, then the combination will be
          <strong>31054232</strong>.
        </span>
      </Footer>

      <BottomButtons className="flex w-full justify-end">
        <SkipButton onClick={() => onProceedWithPassword()}>
          Skip
          <span>For demo use</span>
        </SkipButton>
        <NextButton
          onClick={() => onProceedWithPassword()}
          disabled={dob.length !== 8}
        >
          Next
        </NextButton>
      </BottomButtons>
    </Container>
  );
};

export default DateOfBirth;
